import React from 'react';
import styled from 'styled-components';

const GridContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: row;
  gap: 0.75rem;
  padding-bottom: ${({ $paddingBot = '5%' }) => $paddingBot};
`;

const GridCol = styled.div`
  width: ${({ $colWidth = '33.333333333%' }) => $colWidth};
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 0.75rem;
`;

const GridItem = styled.img`
  display: block;
  width: 100%;
  height: auto;
  margin: auto;
`;

const ThreeColumns = ({
  paddingBot,
  columnOne,
  columnTwo,
  columnThree,
  firstCol,
  secondCol,
  thirdCol,
  ...props
}) => {
  return (
    <>
      <GridContainer $paddingBot={paddingBot}>
        <GridCol $colWidth={firstCol}>
          {columnOne?.map((item, key) => (
            <GridItem {...props} key={key} src={item.src} alt={item.alt} />
          ))}
        </GridCol>
        <GridCol $colWidth={secondCol}>
          {columnTwo?.map((item, key) => (
            <GridItem {...props} key={key} src={item.src} alt={item.alt} />
          ))}
        </GridCol>
        <GridCol $colWidth={thirdCol}>
          {columnThree?.map((item, key) => (
            <GridItem {...props} key={key} src={item.src} alt={item.alt} />
          ))}
        </GridCol>
      </GridContainer>
    </>
  );
};

export default ThreeColumns;
